/** Sticky Header */

const header = document.querySelector('.js-header');
const topBar = document.querySelector('.announcement-bar');
const hero = document.querySelector('.section-featured-product');

if(header && hero) {
    setHeroPadding();

    window.addEventListener('DOMContentLoaded', setHeroPadding);
    window.addEventListener('load', setHeroPadding);
    window.addEventListener('resize', setHeroPadding);
    window.addEventListener('scroll', stickyHeader);
    stickyHeader(window.scrollY);

    window.addEventListener('resize', () => {
        let headerHeight = header.offsetHeight;
        hero.style.paddingTop = `${headerHeight}px`;
    })

}
function stickyHeader() {
    let wrapper = header.closest('.shopify-section');
    wrapper.classList.add('header-wrapper');

    let topBarHeight = topBar.offsetHeight;
    let headerSticky = document.documentElement.scrollTop;
    if (headerSticky > topBarHeight) {
        wrapper.classList.add("sticky");
    }
    else {
        wrapper.classList.remove("sticky");
    } 
}

function setHeroPadding() {
    const headerHeight = header.offsetHeight;
    hero.style.paddingTop = `${headerHeight}px`;
}
// Navbar trigger
const body = document.querySelector('body');
document.querySelector('.js-navbar-trigger')?.addEventListener('click', (event) => {
    event.preventDefault();
    body.classList.toggle('navbar-triggered')
})

document.querySelector('.js-menu-overlay')?.addEventListener('click', closeMenu);
document.querySelectorAll('.js-navbar-item')?.forEach(navBarItem => navBarItem.addEventListener('click', closeMenu));

// Close menu
function closeMenu (event) {
    event.preventDefault();
    body.classList.remove('navbar-triggered');
}